<template>
  <div class=""></div>
</template>
<script >
import { wxauthLogin } from '@/api/home'
export default {
  data() {
    return {
      code: "",
    };
  },
  created() {},
  methods: {
    // 获取二维码参数
    getUrlCode() {
      // 截取url中的code方法
      let url = window.location.href; //'http://wap.kechengzhijia.com/#/invitalpay?'+encodeURIComponent('com_id=5');
      url = decodeURIComponent(url);
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1];
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    wxauthLogin() {
        var data = { 
          'code': this.code,
        } ;
        wxauthLogin(data).then(res => {   
            res=res.data
            if (res.data.isSettingPwdQuestion == 0) {
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          this.$message.info(
            '检测到您尚未设置密保问题,需要先设置密保问题。设置完密保问题系统会帮您自动登录'
          )
          this.$router.push('/user/checkFirstlogin')
        } else {
          // 添加token到localStorage
          window.localStorage.setItem('token', res.data.token)
          // 添加登录ID到localStorage
          localStorage.setItem('userId', res.data.userId)
          localStorage.setItem('schoolIds', res.data.userId)
          // 添加roleType到localStorage
          localStorage.setItem('roleType', res.data.roleType)
          localStorage.setItem('roleTypes', res.data.roleType)
          // 提示登录成功
          this.$message({
            message: '登录成功',
            type: 'success',
          })
          // 跳转到工作台
          this.$router.push('/bench')
        }
          }).catch(r => { 
            
        }); 
    },
  },
  mounted() {
    this.code = this.getUrlCode().auth_code.split("#")[0];
    this.wxauthLogin()
  },
};
</script>

<style scoped>
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/views/qywx/index.vue